module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Ruller-f761a193ead1bbbbdc8f6e90ad0f6187db9e24bc1f8717c80154676e0628759b.svg";